import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import _EntityViewMixin from '../../moreCore/UI/EntityBased/EntityView/EntityView';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import { GenericDialogTypes } from "../../moreCore/UI/GenericDialog/GenericDialogTypes";
import { SelectEntityDialog, SelectEntityDialogTypes } from "../../moreCore/_loadingHelpers/SelectEntityDialog";
import CommdocEditor from './CommdocEditor/CommdocEditor';
import documentEditor from '../fileEditor/documentEditor/documentEditor';
import _WidgetBase from 'dijit/_WidgetBase';

class CommdocView extends compose(_EntityViewMixin<DocumentEntity>) {
   /**
    *
    * @param entityId
    * @param label
    * @param additionalParams
    * @param tabContainerName Name des Tabcontainers, in die die Ansicht ggf. maximiert werden kann
    * @param contextName Beliebiger Kontextname, der im Backend eine Differenzierung zum Zweck der Ansicht zulässt
    * @param disableDefaultButtons Entfernt die Standardbuttons für Reports, Löschen und sonstige Entity-Interaktionen. Neue Buttons können mit addButton eingefügt werden.
    */
    setup(entityId: string,
        label: string,
        additionalParams?: Object,
        contextName?: string,
        tabContainerName?: string) {

        if (additionalParams) {
            this.config.additionalRequestParams = lang.clone(additionalParams);
        }

        if (contextName) this.setContextName(contextName);

        this.showAsDlg(entityId, label, tabContainerName);
       
    }



    onShow() {
    
    }

    onDataLoaded() {
        if (this.useDefaultButtons !== false) {
            this.handleAdditionalButtons();
        }    
    }

    private handleAdditionalButtons() {
        let file = this.entity.ref_vt_files;
        let signatureEntity = this.entity.ref_signature_entity;
        let status = this.entity.ref_doc_status;
        let isNotRelevant = this.entity.is_notRelevant;
        let isDraft = this.entity.is_draft;
        let isCreated = this.entity.is_created;
        let isClosed = this.entity.is_closed;
        let isArchived = this.entity.is_archived;


        this.addButtonMenuEx({
            internalName: "editDocumentMenu",
            bIsGroupNextLevel: true,
            iconClass: "fas fa-edit",
            label: this.translate("DocumentEditor_Label_EditDocumentMenu"),
            parentGroupName: null
        });

        this.addButtonMenuEx({
            internalName: "documentStatusMenu",
            bIsGroupNextLevel: true,
            iconClass: "fas fa-file-alt",
            label: this.translate("DocumentEditor_Label_DocumentStatusMenu"),
            parentGroupName: null
        });

        this.addButtonMenuEx({
            internalName: "documentSignatureMenu",
            bIsGroupNextLevel: true,
            iconClass: "fas fa-file-signature",
            label: this.translate("DocumentEditor_Label_DocumentSignatureMenu"),
            parentGroupName: null
        });

        this.addButtonMenuEx({
            internalName: "servicePositionsMenu",
            bIsGroupNextLevel: true,
            iconClass: "fas fa-briefcase",
            label: this.translate("DocumentEditor_Label_ServicePositionsMenu"),
            parentGroupName: null
        });

        if (file && !signatureEntity && this.hasFeature("DigitalSignature/DigitalSignatureEditor")) {
            this.addButtonEx(
                {
                    internalName: "createSignature",
                    callback: lang.hitch(this, this._onClickCreateSignatureObject),
                    label: 'Document_Label_CreateSignatureObject',
                    iconClass: 'fas fa-signature',
                    bCloseOnClick: false,
                    position: "secondary",
                    groupname: "documentSignatureMenu"
                });
        } else {
            this.requestContextButtonRemove("createSignature");
        }

        if (isDraft) {
            if (this.hasFeature("Document", "createDocument")) {
                this.addButtonEx(
                    {
                        callback: lang.hitch(this, this._onClickCreateCommdoc),
                        internalName: "createDocument",
                        label: this.translate("CommdocList_ButtonTitle_Create"),
                        iconClass: "fas fa-file-import",
                        bCloseOnClick: false,
                        enabled: isDraft,
                        groupname: "editDocumentMenu",
                        position: "secondary",
                        order: 2
                    }
                );
            }

            if (this.hasFeature("documentEditor", "useInCommdoc")) {
                this.addButtonEx(
                    {
                        callback: lang.hitch(this, this._onClick_EditCommdoc),
                        internalName: "editFinalText",
                        label: this.translate("CommdocList_ButtonTitle_DocumentEditor"),
                        iconClass: "fas fa-pencil-ruler",
                        bCloseOnClick: false,
                        enabled: isDraft,
                        groupname: "editDocumentMenu",
                        position: "secondary",
                        order: 1
                    }
                );

                if (this.hasFeature("Document", "generateDraft")) {
                    this.addButtonEx(
                        {
                            callback: lang.hitch(this, this._onClickGenerateDraftCommdoc),
                            internalName: "generateDraft",
                            label: this.translate("CommdocList_ButtonTitle_GenerateDraft"),
                            iconClass: "fas fa-file-signature",
                            bCloseOnClick: false,
                            enabled: isDraft,
                            groupname: "editDocumentMenu",
                            position: "secondary",
                            order: 0
                        }
                    );
                }
                if (this.hasFeature("Document", "selectPosEvServ")) {
                    this.addButtonEx(
                        {
                            callback: lang.hitch(this, this._onClickSelectPosEvServ),
                            internalName: "selectPosEvServ",
                            label: this.translate("CommdocList_ButtonTitle_SelectPosEvServ"),
                            iconClass: "fas fa-mouse-pointer",
                            bCloseOnClick: false,
                            enabled: isDraft,
                            groupname: "servicePositionsMenu",
                            position: "secondary",
                            order: 0
                        }
                    );
                }

            }
        } else {
            this.requestContextButtonRemove("createDocument");
            this.requestContextButtonRemove("generateDraft");
            this.requestContextButtonRemove("editFinalText");
            this.requestContextButtonRemove("selectPosEvServ");
            this.requestContextButtonRemove("delete");
        }

        if (!isClosed && !isNotRelevant && !status?.is_finished && !isArchived) {
            if (this.hasFeature("Document", "closeDocument")) {
                this.addButtonEx(
                    {
                        callback: lang.hitch(this, this._onClickCloseCommdoc),
                        internalName: "closeDocument",
                        label: this.translate("CommdocList_ButtonTitle_Close"),
                        iconClass: "fas fa-ban",
                        bCloseOnClick: false,
                        enabled: !isClosed && !isNotRelevant && !status?.is_finished && !isArchived,
                        groupname: "documentStatusMenu",
                        position: "secondary"
                    }
                );
            }
            if (this.hasFeature("Document", "archiveDocument")) {
                this.addButtonEx(
                    {
                        callback: lang.hitch(this, this._onClickArchiveCommdoc),
                        internalName: "archiveDocument",
                        label: this.translate("CommdocList_ButtonTitle_Archive"),
                        iconClass: "fas fa-archive",
                        bCloseOnClick: false,
                        enabled: !isClosed && !isNotRelevant && !status?.is_finished && !isArchived,
                        groupname: "documentStatusMenu",
                        position: "secondary",
                    }
                );
            }
        } else {
            this.requestContextButtonRemove("closeDocument");
            this.requestContextButtonRemove("archiveDocument");
            this.requestContextButtonRemove("save");
            this.requestContextButtonRemove("rollback");
        }

        if (this.hasFeature("Document", "releaseIsFinished") && this.hasUserRole("Commdoc_Admin") && !isDraft) {
            this.addButtonEx(
                {
                    callback: lang.hitch(this, this._onClickRleaseIsFinishedCommdoc),
                    internalName: "releaseIsFinished",
                    label: this.translate("CommdocList_ButtonTitle_ReleaseIsFinished"),
                    iconClass: "fas fa-undo",
                    bCloseOnClick: false,
                    enabled: !isDraft,
                    groupname: "documentStatusMenu",
                    position: "secondary",
                }
            );
        } else {
            this.requestContextButtonRemove("releaseIsFinished");
        }
    }

    private _onClick_EditCommdoc(): void {
        this.StandbyStart();

        let entityID = this.entity.ID;

        this.RequestManager.callfunction(
            "Webtool_API_SyncfusionDocumentEditor__CommDocFinalText_Fetch",
            {
                commdocId: entityID
            },
            lang.hitch(this, this._onEditCommdocResponse, entityID),
            lang.hitch(this, this._onEditCommdocError)
        );
    }

    private docEdit: MdsLax<InstanceType<typeof documentEditor>>;
    private async _onEditCommdocResponse(entityID: string, resp: { base64Content: string, ext: string, isReadOnly: boolean }) {
        this.docEdit = new documentEditor();
        if (resp.isReadOnly == true) {
            this.docEdit.config.isReadOnly = true;
            this.showToast("DocumentEditor_Msg_ReadOnly", "fas fa-lock");
        }
        await this.docEdit.openDocument(atob(resp.base64Content), false, true);
        if (resp.isReadOnly == true) {
            this.docEdit.dlg._setHeaderAttr(this.translate("DocumentEditor_ViewDoc"));
            this.docEdit.dlg.removeButton("save");
            this.docEdit.dlg.keepOpen = false;
        } else {
            //this.docEdit.dlg.keepOpen = true;
        }
        this.docEdit.on("dlgClosedSaved", lang.hitch(this, this.commDocEditor_SaveDocument, entityID));
        this.docEdit.on("dlgClosedClose", lang.hitch(this, () => {
            if (typeof this.docEdit.dlg.keepOpen == 'boolean') {
                if (this.docEdit.dlg.keepOpen == true) {
                    this.docEdit.dlg.close(null, true); //wir muessen manuell schliessen wenn keepOpen true ist...
                }
            }
        }));
        this.StandbyStop();
    }

    private async commDocEditor_SaveDocument(entityID: string) {
        this.docEdit.StandbyStart();
        let sfdt: string;
        try {
            sfdt = await this.docEdit.exportAsSfdt();
        } catch (err) {
            console.error(err);
            this.showToast(this.translate("DocumentEditor_Error_onSave"), "fas fa-exclamation-triangle");
            this.docEdit.StandbyStop();
            return; //wenn das docEditor widget beim laden geschlossen wird, kann nicht gespeichert werden
        }
        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API_SyncfusionDocumentEditor__CommDocFinalText_Write",
            {
                base64Content: btoa(sfdt),
                commdocId: entityID
            },
            lang.hitch(this, (res) => {
                this.StandbyStop();
                this.docEdit.StandbyStop();
                console.info("document saved", res);
                this.showToast(this.translate("General_Notification_SaveSuccess"), "far fa-save");
            }),
            lang.hitch(this, (err) => {
                this.StandbyStop();
                this.docEdit.StandbyStop();
                console.error(err.Message);
                this.showToast(err.Message, "fas fa-bug");
            })
        );
    }

    private _onEditCommdocError(error): void {
        console.error(error.Message);
        this.showToast(error.Message, "fas fa-exclamation-circle");
        this.StandbyStop();
    }

    private _onClickCreateCommdoc(): void {
        let file = this.entity.ref_vt_files;
        let fileLink = this.entity.filelink;

        if (file || fileLink) {
            let dlg = new GenericDialog();

            dlg.setup({
                content: "DocumentEditor_Message_CreateDocument",
                header: `${this.translate("DocumentEditor_Heading_CreateDocument")} - ${this.title}`,
                buttonPreset: "yesno",
                contentIconClass: GenericDialogTypes.DialogIcon.warning,
                callbackConfig: {
                    yesCallback: lang.hitch(this, this._sendCreateCommdocRequest)
                }
            })
        } else {
            this._sendCreateCommdocRequest();
        }




    }

    private _sendCreateCommdocRequest(): void {
        this.StandbyStart();
        let requestData = {
            ID: this.entity.ID,
            Classname: this.entity.Classname
        }

        this.RequestManager.callfunction("Webtool_API_Document__DocumentEditor_CreateStatusDocument", requestData, lang.hitch(this, this._onCreateCommdocResponse), lang.hitch(this, this._onCreateCommdocError));
    }

    private _onCreateCommdocResponse(response): void {
        this.StandbyStop();

        this.emit("saved");
        this.showToast("DocumentEditor_Success_CreateStatusDocument", "fas fa-check")
        this.reload();
    }

    private _onCreateCommdocError(error): void {
        this.StandbyStop();
        this.showToast("DocumentEditor_Error_CreateStatusDocument", "fas fa-exclamation-triangle");
        console.error(error);
    }

    private _onClickGenerateDraftCommdoc(): void {
        let textModules = this.entity.EL_ht_text_modul_commdocs_commdoc;

        if (!textModules || textModules?.length <= 0) {
            this.showToast("DocumentEditor_Error_NoTextModules", "fas fa-exclamation-triangle");
            return;
        }

        let final_text = this.entity.final_text;

        if (final_text) {
            let dlg = new GenericDialog;
            dlg.setup({
                header: this.translate("DocumentEditor_Heading_GenerateDraft") + " - " + this.title,
                content: "DocumentEditor_Message_OverrideDraft",
                buttonPreset: "yesno",
                contentIconClass: GenericDialogTypes.DialogIcon.warning,
                callbackConfig: {
                    yesCallback: lang.hitch(this, this._sendGenerateDraftCommdocRequest)
                }
            });
        } else {
            this._sendGenerateDraftCommdocRequest();
        }
    }

    private _sendGenerateDraftCommdocRequest(): void {
        this.StandbyStart();
        let requestData = {
            ID: this.entity.ID,
            Classname: this.entity.Classname
        }

        this.RequestManager.callfunction("Webtool_API_Document__DocumentEditor_GenerateDocumentDraft", requestData, lang.hitch(this, this._onGenerateDraftCommdocResponse), lang.hitch(this, this._onGenerateDraftCommdocError));
    }

    private _onGenerateDraftCommdocResponse(response: { message: string, final_text: string }): void {
        this.StandbyStop();

        this.reload();

        this.showToast("DocumentEditor_Success_GenerateDocumentDraft", "fas fa-check");
    }

    private _onGenerateDraftCommdocError(error): void {
        this.StandbyStop();
        this.showToast("DocumentEditor_Error_GenerateDocumentDraft", "fas fa-exclamation-triangle");
        console.error(error);
    }

    private _onClickArchiveCommdoc(): void {
        let dlg = new GenericDialog();
        dlg.setup({
            content: "DocumentEditor_Message_ArchiveCommdoc",
            header: `${this.translate("DocumentEditor_Heading_ArchiveCommdoc")} - ${this.title}`,
            buttonPreset: "yesno",
            contentIconClass: GenericDialogTypes.DialogIcon.warning,
            callbackConfig: {
                yesCallback: lang.hitch(this, this._sendArchiveCommdocRequest)
            }
        });
    }

    private _sendArchiveCommdocRequest(): void {
        this.StandbyStart();
        let requestData = {
            ID: this.entity.ID,
            Classname: this.entity.Classname
        }

        this.RequestManager.callfunction("Webtool_API_Document__DocumentEditor_ArchiveDocument", requestData, lang.hitch(this, this._onArchiveCommdocResponse), lang.hitch(this, this._onArchiveCommdocError));
    }

    private _onArchiveCommdocResponse(response): void {
        this.StandbyStop();

        this.emit("saved");
        this.showToast("DocumentEditor_Success_ArchiveDocument", "fas fa-check");
        this.reload();
    }

    private _onArchiveCommdocError(error): void {
        this.StandbyStop();
        this.showToast("DocumentEditor_Error_ArchiveDocument", "fas fa-exclamation-triangle");
        console.error(error);
    }

    private _onClickRleaseIsFinishedCommdoc(): void {
        let dlg = new GenericDialog();
        dlg.setup({
            content: "DocumentEditor_Message_ReleaseIsFinishedDocument",
            header: `${this.translate("DocumentEditor_Heading_ReleaseIsFinishedDocument")} - ${this.title}`,
            buttonPreset: "yesno",
            contentIconClass: GenericDialogTypes.DialogIcon.warning,
            callbackConfig: {
                yesCallback: lang.hitch(this, this._sendRleaseIsFinishedCommdocRequest)
            }
        });
    }

    private _sendRleaseIsFinishedCommdocRequest(): void {
        this.StandbyStart();
        let requestData = {
            ID: this.entity.ID,
            Classname: this.entity.Classname
        }

        this.RequestManager.callfunction("Webtool_API_Document__DocumentEditor_ReleaseIsFinished", requestData, lang.hitch(this, this._onRleaseIsFinishedCommdocResponse), lang.hitch(this, this._onRleaseIsFinishedCommdocError));
    }

    private _onRleaseIsFinishedCommdocResponse(response): void {
        this.StandbyStop();

        this.emit("saved");
        this.showToast("DocumentEditor_Success_ReleaseIsFinishedDocument", "fas fa-check");
        this.reload();
    }

    private _onRleaseIsFinishedCommdocError(error): void {
        this.StandbyStop();
        this.showToast("DocumentEditor_Error_ReleaseIsFinishedDocument", "fas fa-exclamation-triangle");
        console.error(error);
    }

    private _onClickCloseCommdoc(): void {
        let dlg = new GenericDialog();
        dlg.setup({
            content: "DocumentEditor_Message_CloseCommdoc",
            header: `${this.translate("DocumentEditor_Heading_CloseCommdoc")} - ${this.title}`,
            buttonPreset: "yesno",
            contentIconClass: GenericDialogTypes.DialogIcon.warning,
            callbackConfig: {
                yesCallback: lang.hitch(this, this._sendCloseCommdocRequest)
            }
        });
    }

    private _sendCloseCommdocRequest(): void {
        this.StandbyStart();
        let requestData = {
            ID: this.entity.ID,
            Classname: this.entity.Classname
        }

        this.RequestManager.callfunction("Webtool_API_Document__DocumentEditor_CloseDocument", requestData, lang.hitch(this, this._onCommdocCloseResponse), lang.hitch(this, this._onCommdocCloseError));
    }

    private _onCommdocCloseResponse(response): void {
        this.StandbyStop();

        this.emit("saved");
        this.showToast("DocumentEditor_Success_CloseDocument", "fas fa-check");
        this.reload();
    }

    private _onCommdocCloseError(error: more.requestErrorMessage): void {
        this.StandbyStop();
        this.showToast({ title: "DocumentEditor_Error_CloseDocument", message: error?.Message, iconClass: "fas fa-exclamation-triangle", timeout: "permanent", showClose: true });
        console.error(error);
    }

    private _onClickCreateSignatureObject(): void {
        this.StandbyStart();

        let document = this.entity;
        this.RequestManager.callfunction("Webtool_API_Document__DocumentEditor_CreateSignatureObject", { document }, lang.hitch(this, this._onCreateSignatureObjectResponse), lang.hitch(this, this._onCreateSignatureObjectError));
    }

 

    private _onCreateSignatureObjectResponse(response): void {
        this.StandbyStop();
        this.emit("saved");
        this.showToast("DocumentEditor_Success_CreateSignatureObject", "fas fa-check");
        this.reload();
    }

    private _onCreateSignatureObjectError(error): void {
        this.StandbyStop();
        this.showToast("DocumentEditor_Error_CreateSignatureObject", "fas fa-exclamation-triangle");
        console.error(error);
    }

    private _onClickSelectPosEvServ(): void {

        let sed = new SelectEntityDialog();
        sed.setup(
            `${this.translate("DocumentEditor_Heading_SelectService")} - ${this.title}`,
            lang.hitch(this, this._onSelectPosEvServCallback),
            "Webtool_API_Document__DocumentEditor_GetAvailablePosEvServ",
            10,
            null,
            { minSelect: 1, maxSelect: null },
            null, null, null,
            true
        );

        sed.addRequestParameter("entityId", this.entityID);

        sed.show();
    }

    private _onSelectPosEvServCallback(values: Array<string>, items: Array<SelectEntityDialogTypes.Item<PosEvServ>>) {
        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API_Document__DocumentEditor_AssignPosEvServ",
            { entityId: this.entityID, posEvServList: values },
            lang.hitch(this, this._onSelectPosEvServResponse),
            lang.hitch(this, this._onSelectPosEvServError)
        )
    }

    private _onSelectPosEvServResponse(response): void {
        this.StandbyStop();
        this.showToast("DocumentEditor_Success_CreateSignatureObject", "fas fa-check");
        this.reload();
    }

    private _onSelectPosEvServError(error): void {
        this.StandbyStop();
        this.showToast("DocumentEditor_Error_CreateSignatureObject", "fas fa-exclamation-triangle");
    }

    protected onRequestEditor(entityID: string, entity: DocumentEntity): MdsLax<InstanceType<typeof _WidgetBase>> {
        let editor = new CommdocEditor();
        editor.setup(entity.Classname, entityID, null, null);
        editor.setStartupState("loading");
        editor.on("saved", lang.hitch(this, this.emit, "saved"));
        editor.on("deleted", lang.hitch(this, this.emit, "saved"));

        return editor;
    }

    postCreate(): void {

        this.config = {
            entityClassname: "vt_commdocs",
            labelProperty: "$Displayname",
            entityClassPrintname: this.translate("General_Label_Document"),
            editOptions: {
                userroleEdit: "Commdoc_Edit",
                featurePathEdit: "Commdoc/DocumentEditor",
                onChangedEventName: "change",
                onDeletedEventName: "deleted",
                onSavedEventName: "saved"
            },
            deleteOptions: {
                userroleDelete: "Commdoc_Delete",
            }
        }
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(CommdocView);
